export default "__VITE_ASSET__ZgN6Es8o__"